import React from "react";
import { ZONE_COLOURS, zoneFloors } from "../../utils/heartRateZones";

// Zone colours are shared app-wide (utils/heartRateZones ZONE_COLOURS).
const NAMES = ["Very light", "Easy", "Moderate", "Hard", "Maximum"];

const minutes = (secs) => {
  const m = Math.round(secs / 60);
  return m < 1 && secs > 0 ? "<1 min" : `${m} min`;
};

/**
 * Time in each heart-rate zone for one session (#94), from the zone summary
 * saved with it. Zones are heart-rate reserve bands worked out from the max
 * and resting heart rates stored alongside, so they don't shift if the
 * Profile changes later.
 */
const HeartRateZones = ({ zones }) => {
  const seconds = zones?.seconds;
  if (!Array.isArray(seconds) || seconds.slice(1).every((s) => !s)) return null;
  const longest = Math.max(1, ...seconds.slice(1));
  const floors = zoneFloors({ max: zones.max, resting: zones.resting, method: zones.method });

  return (
    <div className="grid gap-1.5" role="table" aria-label="Time in heart-rate zones">
      {NAMES.map((name, i) => {
        const secs = seconds[i + 1] || 0;
        const upper = i < 4 ? floors[i + 1] - 1 : zones.max;
        return (
          <div key={name} role="row" className="grid grid-cols-[6.5rem_minmax(0,1fr)_3.5rem] items-center gap-2 text-xs">
            <span role="cell" className="text-muted-foreground">
              <span className="font-semibold text-foreground">Z{i + 1}</span> {name}
            </span>
            <span role="cell" className="h-2 rounded-full bg-white/5" title={`${floors[i]}–${upper} bpm`}>
              <span
                className="block h-2 rounded-full"
                style={{ width: secs ? `${Math.max(4, (secs / longest) * 100)}%` : 0, background: ZONE_COLOURS[i + 1] }}
              />
            </span>
            <span role="cell" className="text-right tabular-nums text-foreground">
              {minutes(secs)}
            </span>
          </div>
        );
      })}
      <p className="text-[11px] text-muted-foreground">
        Zones from your max ({zones.max}) and resting ({zones.resting}) heart rate.
      </p>
    </div>
  );
};

export default HeartRateZones;
